module.exports = __webpack_public_path__ + "static/img/3-nei-ying.68eddf0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/3-nei-ying.png
// module id = r9O3
// module chunks = 1